import { render, staticRenderFns } from "./kendo-simple-multiselect.vue?vue&type=template&id=1ac78c34&scoped=true"
import script from "./kendo-simple-multiselect.vue?vue&type=script&lang=js"
export * from "./kendo-simple-multiselect.vue?vue&type=script&lang=js"
import style0 from "./kendo-simple-multiselect.vue?vue&type=style&index=0&id=1ac78c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac78c34",
  null
  
)

export default component.exports